import { lsTest } from './localstorage';
const LAST_JOBSEARCH_PATH_KEY = 'last-jobsearch-path';
const splitHash = (path) => path.split('#')[0] || '';
const normalizeTrailingSlash = (path) => {
    if (path === '/') {
        return path;
    }
    return path.replace(/\/+$/, '') || '/';
};
const normalizeLastJobsearchPath = (path) => {
    if (typeof path !== 'string') {
        return null;
    }
    const trimmedPath = path.trim();
    if (!trimmedPath.startsWith('/')) {
        return null;
    }
    const pathWithoutHash = splitHash(trimmedPath);
    const [pathname = '', ...queryParts] = pathWithoutHash.split('?');
    const normalizedPathname = normalizeTrailingSlash(pathname);
    const query = queryParts.length ? `?${queryParts.join('?')}` : '';
    if (normalizedPathname === '/pwa') {
        return '/pwa';
    }
    if (normalizedPathname === '/jobs' || normalizedPathname.startsWith('/jobs/')) {
        return `${normalizedPathname}${query}`;
    }
    return null;
};
export const saveLastJobsearchPath = (path) => {
    if (!lsTest()) {
        return;
    }
    const normalizedPath = normalizeLastJobsearchPath(path);
    if (!normalizedPath) {
        return;
    }
    const currentPath = localStorage.getItem(LAST_JOBSEARCH_PATH_KEY);
    if (currentPath === normalizedPath) {
        return;
    }
    localStorage.setItem(LAST_JOBSEARCH_PATH_KEY, normalizedPath);
};
export const getLastJobsearchPath = () => {
    if (!lsTest()) {
        return null;
    }
    const storedPath = localStorage.getItem(LAST_JOBSEARCH_PATH_KEY);
    if (!storedPath) {
        return null;
    }
    const normalizedPath = normalizeLastJobsearchPath(storedPath);
    if (!normalizedPath) {
        localStorage.removeItem(LAST_JOBSEARCH_PATH_KEY);
        return null;
    }
    return normalizedPath;
};
export const resolveLastJobsearchPath = (fallback = '/jobs') => { var _a; return (_a = getLastJobsearchPath()) !== null && _a !== void 0 ? _a : fallback; };
//# sourceMappingURL=jobsearchNavigation.js.map